import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { DialogContentData, Subtype } from '../PublishOptimizationResultButton.d'

type DialogDescriptionProps = {
  dialogContent: DialogContentData
  selectedSubtype: Subtype | null
}

export default function DialogDescription({
  dialogContent,
  selectedSubtype,
}: DialogDescriptionProps): ReactElement | null {
  const { t } = useTranslation()
  const { state, subtypes, isMultipleSubtypes } = dialogContent

  const subtypeInfo = subtypes[0]

  if (state === 'initial') {
    // If there is no current published optimization.

    if (isMultipleSubtypes) {
      return (
        <p>
          {t(
            'This means that all production plans which were optimized will be published to the production plan module'
          )}
        </p>
      )
    }

    if (!subtypeInfo) {
      return null
    }

    if (selectedSubtype) {
      return (
        <p>
          {t(
            'This means that the production plan for {{subtype}} which was optimized at {{optimizedAt}} will be published to the production plan module',
            { subtype: subtypeInfo.subtypeDisplayName, optimizedAt: subtypeInfo.latestWipTimestamp }
          )}
        </p>
      )
    }
  }

  if (state !== 'ok_to_publish') {
    return null
  }

  if (isMultipleSubtypes) {
    return (
      <p>{t('This means that all production plans which were optimized will replace the currently published plans')}</p>
    )
  }

  if (!subtypeInfo) {
    return null
  }

  if (selectedSubtype) {
    return (
      <p>
        {t(
          'This means that the production plan for {{subtype}} which was optimized at {{optimizedAt}} will replace the plan that was published at {{latestPublishedAt}}',
          {
            subtype: subtypeInfo.subtypeDisplayName,
            optimizedAt: subtypeInfo.latestWipTimestamp,
            latestPublishedAt: subtypeInfo.latestPublishedTimestamp,
          }
        )}
      </p>
    )
  }

  return (
    <p>
      {t(
        'This means that the production plan which was optimized at {{optimizedAt}} will replace the plan that was published at {{latestPublishedAt}}',
        {
          optimizedAt: subtypeInfo.latestWipTimestamp,
          latestPublishedAt: subtypeInfo.latestPublishedTimestamp,
        }
      )}
    </p>
  )
}
